import Axios from 'axios';
import { boot } from 'quasar/wrappers';
import { Routes } from 'src/constants';
import { useAccountStore } from 'src/stores/account';

export default boot(({ redirect }) => {
	const runtimeEnvironment = process.env.RUNTIME_ENVIRONMENT as
		| 'DEV'
		| 'STAGING'
		| 'PROD';

	if (runtimeEnvironment === 'DEV') {
		Axios.defaults.baseURL = process.env.DEV_API_BASE_URL;
	} else if (runtimeEnvironment === 'STAGING') {
		Axios.defaults.baseURL = process.env.STAGING_API_BASE_URL;
	} else {
		Axios.defaults.baseURL = process.env.PROD_API_BASE_URL;
	}

	Axios.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error?.response?.status === 401) {
				const accountStore = useAccountStore();
				accountStore.logout();
				redirect({ name: Routes.LOG_IN });
			}
			return Promise.reject(error);
		}
	);
});
